/**
 * `Object.keys`, but typed!
 * @param o Some key:value object
 */
export const keys = <T extends { [key: string]: any }>(o: T) => Object.keys(o) as (keyof T)[];

/**
 * `Object.values`, but typed!
 * @param o Some key:value object
 */
export const values = <T extends { [key: string]: any }>(o: T) => Object.values(o) as T[keyof T][];

/**
 * `Object.entries`, but typed!
 * @param o Some key:value object
 */
export const entries = <T extends { [key: string]: any }>(o: T) => Object.entries(o) as [keyof T, T[keyof T]][];
